import React, { Component, useRef, useEffect } from "react";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";

import Title from "../components/Title";

import Revolver from "../sketches/Revolver";


const Dawn = () => {

    return (
        <>
            <Responsive />
            <div className="book-wrapper">
                <div className="left-con bg-s1">
                    {/* <Title /> */}
                    <div className="contents-wrapper">
                        <div className="canvas-wrapper">
                            <Revolver />
                        </div>
                        <div className="element-wrapper">
                            <div className="clip">
                                
                            </div>
                        </div>
                    </div>
                </div>
                <BasicLayout />
            </div>
        </>
    )
};

export default Dawn;